export const PROJECT_LIST = 'project-list'
export const PROJECT_ITEM = 'project-item'
export const EMPTY_PROJECT_LIST = 'empty-project-list'
export const CTA_SIGN_IN = 'cta-sign-in'
export const CTA_SIGN_UP = 'cta-sign-up'
